const styles = {
    text:{
        color: "#818C99",
        fontFamily: "Roboto",
        fontSize: "16px",
        lineHeight: "20px",
        letterSpacing: "0.1px",
        textAlign: "center"
    },
    firstLine: {
        marginTop: "32vh"
    },
    secondLine: {

    },
    orderButton: {
        width: "174px",
        minWidth: "174px",
        height: "36px",
        backgroundColor: "#06844D",
        borderRadius: "8px",
        fontSize: "15px",
        fontWeight: "500",
        fontFamily: "Roboto",
        display: 'block',
        marginLeft:"auto",
        marginRight: "auto",
        marginTop: "24px",
        whiteSpace: "nowrap"
    }
}

export default styles;
